// extracted by mini-css-extract-plugin
module.exports = {"mobile_buttons":"MobileButtons_mobile_buttons__16xoJ","mob_but":"MobileButtons_mob_but__eBh3-"};